const ContractStatus = {
  ACTIVE: "ACTIVE",
  DEACTIVE: "DEACTIVE",
  UPCOMING: "UPCOMING",
  EXPIRED: "EXPIRED"
};

export default ContractStatus;
